module.exports = __webpack_public_path__ + "static/curso04-0dfdaa0886adbcfcd5f49ad7faf8779d.png";